<template>
  <div class="choose-monthly-deposit">
    <div class="r-text-intro">אפשר גם, אבל לא חובה</div>
    <div class="r-text-headline-paragraph">להעביר חד פעמית סכום פנוי שיש לך</div>
    <div class="r-form">
      <div class="r-form-row">
        <default-text-input
          :value="oneTimeDepositSum"
          label="סכום"
          placeholder="0"
          type="tel"
          :validations="`numeric|maxDeposit:${maxOneTimeDeposit}|minDeposit:100`"
          autofocus
          @observe="observe"
          @input="setDepositSum" />
      </div>
    </div>

    <default-button label="הבא >" @click="nextPage" :disable="locked" :loading="locked"/>
  </div>
</template>

<script>
import _ from 'lodash';
import WizardPage from '@/mixins/WizardPage';
import { mapMutations, mapState } from 'vuex';
import DefaultButton from '@/components/styled/DefaultButton';
import MoneyFormat from '@/mixins/MoneyFormat';
import DefaultTextInput from '@/components/styled/DefaultTextInput';
import ValidationObserver from '@/mixins/ValidationObserver';
import { calcMaxOneTime } from '@/utils/kgl';

export default {
  name: 'ChooseOneTimeDeposit',
  components: { DefaultTextInput, DefaultButton },
  mixins: [WizardPage, MoneyFormat, ValidationObserver],
  computed: {
    ...mapState('meitavDash/openFund', ['oneTimeDepositSum', 'monthlyDepositSum']),
    maxOneTimeDeposit() {
      return calcMaxOneTime(this.monthlyDepositSum);
    },
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setOneTimeDepositSum']),
    setDepositSum(value) {
      if (_.isNil(value)) {
        this.setOneTimeDepositSum(0);
        return;
      }

      const numericValue = Number(value);
      if (_.isNaN(numericValue)) {
        this.setOneTimeDepositSum(value);
        return;
      }
      this.setOneTimeDepositSum(numericValue);
    },
  },
};
</script>
